module.exports = __webpack_public_path__ + "static/media/setting.df82467c.svg";